import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable */
/**
 * Health
 * Ab Initio Health Services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/health.yaml
// Template file: apiServices.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbBasicHealthInfoFactory } from "../dto/AbBasicHealthInfo";
// @ts-ignore noUnusedLocals
import { AbHealthInfoFactory } from "../dto/AbHealthInfo";
// @ts-ignore noUnusedLocals
import { AbVersionInfoFactory } from "absdk/commons/api/dto/AbVersionInfo";
import { AbWebServices } from "abweb/service/AbWebServices";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { StringUtils } from "abweb/utils/StringUtils";
import { URLUtils } from "abweb/utils/URLUtils";
// @ts-ignore noUnusedLocals

// @ts-ignore noUnusedLocals

export class HealthApiServices {
  static initDefaultServices() {
    HealthApiServices.buildApiService(AbWebServices.getRPCService(), "", true, true);
  }
  static buildApiService(rpcService, proxyLabel, isDefault, isLocal = false) {
    if (HealthApiServices.serviceMap.has(proxyLabel)) {
      HealthApiServices.LOG.warn("Already initialized HealthApiServices. Call resetServices before re-initializing.");
    }
    proxyLabel = StringUtils.emptyIfNull(proxyLabel);
    const healthApi = new HealthApiInvoker(rpcService);
    HealthApiServices.serviceMap.set(proxyLabel, healthApi);

    // If the service is considered "default" and the proxyLabel is not "" you would
    // usually also set it as the service identified by the empty label. However,
    // we know that it is possible that an application may want to host non-proxied services
    // in addition to proxied ones. In that case, DO NOT clear out the native service
    // that is already stored with the empty label.
    if (isLocal || isDefault && proxyLabel !== "" && HealthApiServices.serviceMap.get("") == null) {
      HealthApiServices.serviceMap.set("", healthApi);
    }
    return healthApi;
  }
  static getHealthApi(proxyLabel) {
    proxyLabel = StringUtils.emptyIfNull2(proxyLabel);
    let services = HealthApiServices.serviceMap.get(proxyLabel);
    if (!services) {
      services = HealthApiServices.serviceMap.get(proxyLabel);
      if (!services) {
        throw new Error(`No proxy service found for proxy label '${proxyLabel}'`);
      }
    }
    return services;
  }
  static resetServices() {
    HealthApiServices.serviceMap.clear();
  }
}
_defineProperty(HealthApiServices, "LOG", LogUtils.getLogger("HealthApiServices"));
_defineProperty(HealthApiServices, "serviceMap", new Map());
class HealthApiInvoker {
  constructor(rpcService) {
    _defineProperty(this, "rpcService", void 0);
    this.rpcService = rpcService;
  }
  async getBasicHealthInfo() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/basic", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbBasicHealthInfoFactory.FromJSON(response);
    return responseObject;
  }
  async getHealthInfo() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/health", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbHealthInfoFactory.FromJSON(response);
    return responseObject;
  }
  async getK8sLiveness() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/k8s/liveness", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
  async getK8sReadiness() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/k8s/readiness", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
  async getK8sStartup() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/k8s/startup", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
  async getVersionInfo() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abwebinternal/health/version", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbVersionInfoFactory.FromJSON(response);
    return responseObject;
  }
}
//# sourceMappingURL=HealthApiServices.js.map
